/* The Art Shoes theme scripts. Progressive enhancement: every page works without JavaScript. */
(function () {
  'use strict';
  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');


  /* ---------- Hero loop frame: looks turn in 3D, products open their Quick Buy link ---------- */
  var hoverQuery = window.matchMedia('(hover: hover)');
  function closeHots(scope, keep) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-loop-hot].is-open'), function (h) {
      if (h === keep) { return; }
      h.classList.remove('is-open');
      var pin = h.querySelector('[data-loop-pin]');
      if (pin) { pin.setAttribute('aria-expanded', 'false'); }
    });
  }
  /* keep the Quick Buy card inside the photograph: open upwards unless the product sits near the top,
     and slide it sideways (in px) so it never crosses the edge of the frame */
  function placeCard(hot) {
    var shot = hot.closest('[data-loop-shot]'), pin = hot.querySelector('[data-loop-pin]'), card = hot.querySelector('.loop__card');
    if (!shot || !pin || !card) { return; }
    var sr = shot.getBoundingClientRect(), pr = pin.getBoundingClientRect();
    var x = pr.left + pr.width / 2 - sr.left, y = pr.top + pr.height / 2 - sr.top;
    var cw = card.offsetWidth, ch = card.offsetHeight, edge = 8;
    var up = y - ch - 28 >= edge, down = y + 28 + ch <= sr.height - edge;
    var top = up ? y - ch - 28 : (down ? y + 28 : Math.max(edge, Math.min(y - ch / 2, sr.height - ch - edge)));
    hot.setAttribute('data-v', up || !down ? 'up' : 'down');
    hot.style.setProperty('--oy', Math.round(top - y) + 'px');
    var left = Math.max(edge, Math.min(x - cw / 2, sr.width - cw - edge));
    hot.style.setProperty('--ox', Math.round(left - x) + 'px');
  }

  function initLoop(el) {
    var scene = el.closest('[data-hero-slide]') || el.parentNode;
    var foot = scene.querySelector('[data-loop-foot]') || el;
    var shots = Array.prototype.slice.call(el.querySelectorAll('[data-loop-shot]'));
    var lists = Array.prototype.slice.call(foot.querySelectorAll('[data-loop-list]'));
    var ticks = Array.prototype.slice.call(foot.querySelectorAll('[data-loop-tick]'));
    var TONE_VARS = ['--l1', '--l2', '--l3', '--b1', '--b2', '--b3', '--inkl', '--inkb', '--revl', '--revb'];
    var stage = el.querySelector('.loop__stage');
    var variant = el.getAttribute('data-variant');
    var n = shots.length, step = 0, cur = 0, turnTimer = 0, leaveTimers = [];

    function offset(k) {
      if (variant === 'deck') { return (k - cur + n) % n; }
      var h = Math.floor(n / 2);
      return ((k - cur + n + h) % n) - h;
    }

    function openDoors(prev) {
      var canvas = prev.querySelector('.loop__canvas');
      if (!canvas || !stage) { return; }
      ['l', 'r'].forEach(function (side) {
        var door = document.createElement('div'), inner = document.createElement('div'), copy = canvas.cloneNode(true);
        door.className = 'loop__door loop__door--' + side;
        door.setAttribute('aria-hidden', 'true');
        inner.className = 'loop__doorin';
        ['--fx', '--fy', '--z'].forEach(function (v) { var val = prev.style.getPropertyValue(v); if (val) { inner.style.setProperty(v, val); } });
        Array.prototype.forEach.call(copy.querySelectorAll('[data-loop-hot]'), function (h) { h.parentNode.removeChild(h); });
        inner.appendChild(copy); door.appendChild(inner); stage.appendChild(door);
        window.setTimeout(function () { if (door.parentNode) { door.parentNode.removeChild(door); } }, 1400);
      });
    }

    function apply(prevIndex, animate) {
      el.style.setProperty('--step', step);
      shots.forEach(function (s, k) {
        var o = offset(k), old = parseFloat(s.style.getPropertyValue('--o'));
        var shaded = variant === 'cover' || variant === 'deck';
        if (variant === 'cover' && animate && !isNaN(old) && Math.abs(o - old) > 1) {
          s.classList.add('is-jump');
          window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { s.classList.remove('is-jump'); }); });
        }
        s.style.setProperty('--o', o);
        s.style.setProperty('--ao', shaded ? Math.min(Math.abs(o), 2) : 0);
        s.classList.toggle('is-current', k === cur);
        if (k === cur) { s.removeAttribute('inert'); s.removeAttribute('aria-hidden'); } else { s.setAttribute('inert', ''); s.setAttribute('aria-hidden', 'true'); }
      });
      /* the banner takes the colours of the photograph on show, so photograph and banner stay one piece */
      var tone = (shots[cur].getAttribute('data-tone') || '').split(' ');
      if (tone.length === TONE_VARS.length) { TONE_VARS.forEach(function (v, i) { scene.style.setProperty(v, tone[i]); }); }
      lists.forEach(function (l, k) { l.classList.toggle('is-current', k === cur); });
      ticks.forEach(function (t, k) { if (k === cur) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); } });
      closeHots(el);
      if (animate && prevIndex !== cur && !reduceQuery.matches) {
        var prev = shots[prevIndex];
        el.classList.add('is-turning');
        window.clearTimeout(turnTimer);
        turnTimer = window.setTimeout(function () { el.classList.remove('is-turning'); }, 1150);
        if (variant === 'fold') { openDoors(prev); }
        if (variant === 'deck' || variant === 'arch') {
          prev.classList.add('is-leaving');
          window.setTimeout(function () { prev.classList.remove('is-leaving'); }, 1300);
        }
      }
    }

    function go(i, instant) {
      var next = ((i % n) + n) % n;
      if (next === cur && !instant) { return; }
      var prev = cur;
      if (instant) {
        step = Math.ceil(step / n) * n;
        el.classList.add('is-instant');
      } else {
        step += ((next - cur + n) % n) || n;
      }
      cur = next;
      apply(prev, !instant);
      if (instant) { window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { el.classList.remove('is-instant'); }); }); }
    }

    /* the arch opens as a circle from the first product in each look */
    function setOrigins() {
      shots.forEach(function (s) {
        var pin = s.querySelector('[data-loop-pin]'), sr = s.getBoundingClientRect();
        if (!pin || !sr.width) { return; }
        var pr = pin.getBoundingClientRect();
        s.style.setProperty('--cx', (((pr.left + pr.width / 2 - sr.left) / sr.width) * 100).toFixed(1) + '%');
        s.style.setProperty('--cy', (((pr.top + pr.height / 2 - sr.top) / sr.height) * 100).toFixed(1) + '%');
      });
    }
    if (variant === 'arch') {
      setOrigins();
      var rt = 0;
      window.addEventListener('resize', function () { window.clearTimeout(rt); rt = window.setTimeout(setOrigins, 150); });
    }

    /* photographs behind the first one are lazy: fetch them once this banner is (nearly) on screen so turns never show an empty card */
    function warm() {
      shots.forEach(function (s) { Array.prototype.forEach.call(s.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; }); });
    }

    ticks.forEach(function (t, k) { t.addEventListener('click', function () { el.dispatchEvent(new CustomEvent('loop:user', { bubbles: true })); go(k); }); });
    apply(0, false);
    return { el: el, count: n, warm: warm, next: function () { go(cur + 1); }, reset: function () { if (cur !== 0) { go(0, true); } } };
  }

  /* hover (mouse), focus (keyboard) or tap (touch) on a product shows its Quick Buy link */
  function initHotspots(root) {
    root.addEventListener('mouseover', function (e) {
      var hot = e.target.closest ? e.target.closest('[data-loop-hot]') : null;
      if (!hot || !hoverQuery.matches) { return; }
      placeCard(hot);
      var pin = hot.querySelector('[data-loop-pin]'); if (pin) { pin.setAttribute('aria-expanded', 'true'); }
    });
    root.addEventListener('mouseout', function (e) {
      var hot = e.target.closest ? e.target.closest('[data-loop-hot]') : null;
      if (!hot || hot.contains(e.relatedTarget) || hot.classList.contains('is-open')) { return; }
      var pin = hot.querySelector('[data-loop-pin]'); if (pin && !hot.contains(document.activeElement)) { pin.setAttribute('aria-expanded', 'false'); }
    });
    root.addEventListener('focusin', function (e) {
      var hot = e.target.closest ? e.target.closest('[data-loop-hot]') : null;
      if (!hot) { return; }
      placeCard(hot);
      var pin = hot.querySelector('[data-loop-pin]'); if (pin) { pin.setAttribute('aria-expanded', 'true'); }
    });
    root.addEventListener('focusout', function (e) {
      var hot = e.target.closest ? e.target.closest('[data-loop-hot]') : null;
      if (!hot || hot.contains(e.relatedTarget) || hot.classList.contains('is-open')) { return; }
      var pin = hot.querySelector('[data-loop-pin]'); if (pin) { pin.setAttribute('aria-expanded', 'false'); }
    });
    root.addEventListener('click', function (e) {
      var pin = e.target.closest ? e.target.closest('[data-loop-pin]') : null;
      if (!pin) { return; }
      var hot = pin.closest('[data-loop-hot]'), buy = hot.querySelector('.loop__buy');
      /* a mouse click on the dot goes straight to the product; touch and keyboard open the card first */
      if (hoverQuery.matches && e.pointerType === 'mouse' && buy) { window.location.href = buy.getAttribute('href'); return; }
      var open = !hot.classList.contains('is-open');
      closeHots(root, hot);
      hot.classList.toggle('is-open', open);
      pin.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { placeCard(hot); }
    });
    document.addEventListener('pointerdown', function (e) { if (!e.target.closest || !e.target.closest('[data-loop-hot]')) { closeHots(root); } });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeHots(root); } });
  }

  /* ---------- Hero carousel ---------- */
  function initHero(root) {
    var viewport = root.querySelector('[data-hero-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var indexEl = root.querySelector('[data-hero-index]');
    var toggle = root.querySelector('[data-hero-toggle]');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6500;
    var current = 0, paused = false, hovering = false, focused = false, timer = null, loopTimer = null, frame = 0;
    var loops = Array.prototype.slice.call(root.querySelectorAll('[data-loop]')).map(initLoop);
    var loopOf = function (i) { var sl = slides[i]; return sl ? loops.filter(function (l) { return sl.contains(l.el); })[0] : null; };
    initHotspots(root);

    function setReduced() { root.classList.toggle('is-reduced', reduceQuery.matches); sync(); }
    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function mark(i) {
      current = i;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-current', n === i);
        if (n === i) { s.removeAttribute('inert'); } else { s.setAttribute('inert', ''); }
      });
      dots.forEach(function (d, n) { if (n === i) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); } });
      if (indexEl) { indexEl.textContent = pad(i + 1); }
      var here = loopOf(current), ahead = loopOf((current + 1) % slides.length);
      if (here) { here.warm(); }
      if (ahead) { ahead.warm(); }
      /* a banner you left starts again from its first look once it is off screen */
      window.setTimeout(function () { loops.forEach(function (l) { if (l !== loopOf(current)) { l.reset(); } }); }, 800);
      sync();
    }

    function go(i, user) {
      var n = (i + slides.length) % slides.length;
      var behavior = reduceQuery.matches ? 'auto' : 'smooth';
      viewport.scrollTo({ left: slides[n].offsetLeft, behavior: behavior });
      mark(n);
      if (user) { paused = true; sync(); }
    }

    var settle;
    viewport.addEventListener('scroll', function () {
      window.clearTimeout(settle);
      settle = window.setTimeout(function () {
        var w = viewport.clientWidth || 1;
        var i = Math.round(viewport.scrollLeft / w);
        if (i !== current) { mark(i); }
      }, 90);
    }, { passive: true });
    viewport.addEventListener('pointerdown', function () { paused = true; sync(); });

    function sync() {
      window.clearInterval(timer);
      var running = !paused && !hovering && !focused && !reduceQuery.matches;
      if (running) { timer = window.setInterval(function () { if (!document.hidden) { go(current + 1); } }, interval); }
      window.clearInterval(loopTimer);
      var active = loopOf(current);
      root.classList.toggle('is-paused', !running);
      if (active && active.count > 1) {
        var dwell = Math.min(3400, Math.max(2000, Math.round(interval / active.count)));
        active.el.style.setProperty('--lp-ms', dwell + 'ms');
        if (running) { loopTimer = window.setInterval(function () { if (!document.hidden) { active.next(); } }, dwell); }
      }
      if (toggle) {
        var off = paused || reduceQuery.matches;
        toggle.querySelector('[data-icon-pause]').hidden = off;
        toggle.querySelector('[data-icon-play]').hidden = !off;
        toggle.setAttribute('aria-label', toggle.getAttribute(off ? 'data-label-play' : 'data-label-pause'));
        toggle.disabled = reduceQuery.matches;
      }
    }

    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n, true); }); });
    var prev = root.querySelector('[data-hero-prev]'), next = root.querySelector('[data-hero-next]');
    if (prev) { prev.addEventListener('click', function () { go(current - 1, true); }); }
    if (next) { next.addEventListener('click', function () { go(current + 1, true); }); }
    if (toggle) { toggle.addEventListener('click', function () { paused = !paused; sync(); }); }
    root.addEventListener('loop:user', function () { paused = true; sync(); });
    root.addEventListener('mouseenter', function () { hovering = true; sync(); });
    root.addEventListener('mouseleave', function () { hovering = false; sync(); });
    root.addEventListener('focusin', function () { focused = true; sync(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { focused = false; sync(); } });
    document.addEventListener('visibilitychange', sync);
    window.addEventListener('resize', function () { viewport.scrollTo({ left: slides[current].offsetLeft, behavior: 'auto' }); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(current - 1, true); } else if (e.key === 'ArrowRight') { go(current + 1, true); }
    });

    /* restrained pointer parallax: fine pointers only, never with reduced motion */
    root.addEventListener('pointermove', function (e) {
      if (reduceQuery.matches || e.pointerType !== 'mouse') { return; }
      var r = root.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 2 - 1, y = ((e.clientY - r.top) / r.height) * 2 - 1;
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () { root.style.setProperty('--px', x.toFixed(3)); root.style.setProperty('--py', y.toFixed(3)); });
    });
    root.addEventListener('pointerleave', function () { root.style.setProperty('--px', '0'); root.style.setProperty('--py', '0'); });

    if (reduceQuery.addEventListener) { reduceQuery.addEventListener('change', setReduced); }
    mark(0); setReduced();
  }

  /* ---------- Discovery rails ---------- */
  function initRail(root) {
    var track = root.querySelector('[data-rail-track]');
    var prev = root.querySelector('[data-rail-prev]'), next = root.querySelector('[data-rail-next]');
    if (!track || !prev || !next) { return; }
    function update() {
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    function page(dir) {
      track.scrollBy({ left: dir * Math.max(160, track.clientWidth * 0.85), behavior: reduceQuery.matches ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].indexOf(e.key) < 0) { return; }
      var items = Array.prototype.slice.call(track.querySelectorAll('a.rail-card, a.pick-card, .look-card a'));
      var at = items.indexOf(document.activeElement);
      if (at < 0) { return; }
      e.preventDefault();
      var n = e.key === 'Home' ? 0 : e.key === 'End' ? items.length - 1 : Math.min(items.length - 1, Math.max(0, at + (e.key === 'ArrowRight' ? 1 : -1)));
      items[n].focus();
      items[n].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Product page ---------- */
  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: fmt, maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function initProduct(root) {
    var form = root.querySelector('[data-product-form]');
    var variants = [];
    var json = root.querySelector('[data-variants]');
    if (json) { try { variants = JSON.parse(json.textContent); } catch (e) { variants = []; } }

    /* gallery */
    var slidesEls = root.querySelectorAll('.gallery__slide');
    root.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () { showMedia(btn.getAttribute('data-thumb')); });
    });
    function showMedia(id) {
      slidesEls.forEach(function (s) { s.hidden = s.getAttribute('data-media-id') !== String(id); });
      root.querySelectorAll('[data-thumb]').forEach(function (b) {
        if (b.getAttribute('data-thumb') === String(id)) { b.setAttribute('aria-current', 'true'); } else { b.removeAttribute('aria-current'); }
      });
    }

    if (!form) { return; }
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add]');
    var err = form.querySelector('[data-form-error]');
    var priceEl = root.querySelector('[data-price]');

    function selected() {
      var vals = [];
      form.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        vals[parseInt(fs.getAttribute('data-option-index'), 10)] = c ? c.value : null;
      });
      return vals;
    }
    function findVariant(vals) {
      return variants.filter(function (v) { return v.options.every(function (o, i) { return vals[i] === o; }); })[0];
    }
    function markUnavailable() {
      form.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        fs.querySelectorAll('input').forEach(function (input) {
          var vals = selected(); vals[idx] = input.value;
          var v = findVariant(vals);
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) { label.classList.toggle('is-unavailable', !v || !v.available); }
        });
      });
    }
    function update() {
      var v = findVariant(selected());
      if (!v) { addBtn.disabled = true; addBtn.innerHTML = addBtn.getAttribute('data-html-sold'); return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.innerHTML = v.available ? addBtn.getAttribute('data-html-add') : addBtn.getAttribute('data-html-sold');
      if (priceEl) {
        priceEl.innerHTML = '<span class="price">' + (v.compare_at_price > v.price ? '<s class="price__compare">' + money(v.compare_at_price) + '</s>' : '') + '<span class="price__now">' + money(v.price) + '</span></span>';
      }
      if (v.featured_media && v.featured_media.id) { showMedia(v.featured_media.id); }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      markUnavailable();
    }
    form.addEventListener('change', function (e) { if (e.target.type === 'radio') { update(); } });
    markUnavailable();

    /* add to bag without leaving the page; falls back to the normal form post */
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !addBtn || addBtn.disabled) { return; }
      e.preventDefault();
      err.hidden = true;
      var original = addBtn.innerHTML;
      addBtn.disabled = true; addBtn.textContent = '…';
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.data.description || res.data.message || 'Could not add this item.'); }
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
          addBtn.textContent = '✓'; 
          window.setTimeout(function () { addBtn.innerHTML = original; addBtn.disabled = false; }, 1400);
        })
        .catch(function (error) { err.textContent = error.message; err.hidden = false; addBtn.innerHTML = original; addBtn.disabled = false; });
    });

    /* related designs in the same colour / style */
    var rec = root.querySelector('[data-recommendations]');
    if (rec && window.fetch) {
      fetch(rec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-recommendations-grid]');
        if (grid && grid.children.length) { rec.querySelector('[data-recommendations-content]').appendChild(grid); rec.hidden = false; }
      }).catch(function () {});
    }
  }

  /* ---------- Small account / collection helpers ---------- */
  function initMisc() {
    document.querySelectorAll('[data-sort-select]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });
    document.querySelectorAll('[data-recover-toggle]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); var box = document.getElementById('recover'); if (box) { box.hidden = !box.hidden; } });
    });
    document.querySelectorAll('[data-address-edit]').forEach(function (b) {
      b.addEventListener('click', function () { var box = document.getElementById('addr-' + b.getAttribute('data-address-edit')); if (box) { box.hidden = !box.hidden; } });
    });
    document.querySelectorAll('[data-delete-form]').forEach(function (f) {
      f.addEventListener('submit', function (e) { if (!window.confirm('Remove this address?')) { e.preventDefault(); } });
    });
    var hash = window.location.hash === '#recover' && document.getElementById('recover');
    if (hash) { hash.hidden = false; }
  }

  /* ---------- Language switch: English, Hindi or both ---------- */
  function setLang(mode, save) {
    if (mode !== 'en' && mode !== 'hi' && mode !== 'both') { return; }
    var root = document.documentElement;
    root.setAttribute('data-lang', mode);
    if (mode === 'hi') { root.lang = 'hi'; } else { root.lang = root.getAttribute('data-page-lang') || 'en'; }
    if (save) { try { window.localStorage.setItem('tas-lang', mode); } catch (e) {} }
    Array.prototype.forEach.call(document.querySelectorAll('[data-lang-set]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-lang-set') === mode ? 'true' : 'false');
    });
  }
  function initLang() {
    var root = document.documentElement;
    if (!root.getAttribute('data-page-lang')) { root.setAttribute('data-page-lang', root.lang === 'hi' ? 'hi' : (root.lang || 'en')); }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lang-set]');
      if (b) { setLang(b.getAttribute('data-lang-set'), true); }
    });
    setLang(root.getAttribute('data-lang') || 'both', false);
  }

  /* ---------- Gentle reveal of the story sections (skipped for reduced motion) ---------- */
  var revealIO = null;
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!els.length) { return; }
    if (!('IntersectionObserver' in window) || reduceQuery.matches) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    revealIO = revealIO || new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(els, function (el) { revealIO.observe(el); });
  }

  /* re-running boot (theme editor section reloads) must not bind a node twice */
  function once(el, name) {
    var key = 'tasInit' + name;
    if (el.dataset && el.dataset[key]) { return false; }
    if (el.dataset) { el.dataset[key] = '1'; }
    return true;
  }

  var langReady = false;
  function boot() {
    document.documentElement.classList.add('js');
    if (!langReady) { langReady = true; initLang(); }
    document.querySelectorAll('[data-hero]').forEach(function (el) { if (once(el, 'Hero')) { initHero(el); } });
    document.querySelectorAll('.rail').forEach(function (el) { if (once(el, 'Rail')) { initRail(el); } });
    document.querySelectorAll('[data-product]').forEach(function (el) { if (once(el, 'Product')) { initProduct(el); } });
    if (!miscReady) { miscReady = true; initMisc(); }
    initReveal();
  }
  var miscReady = false;
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
